export default function Unmuted() {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="33 " height="33" viewBox="0 0 32 33" fill="none">
        <path d="M8 10.2509H0V22.2509H8L18 30.2509V2.25085L8 10.2509Z" fill="#838383" />
        <path d="M22.7783 11.1171C24.4869 12.8283 26.4565 17.6588 22.7783 21.3844" stroke="#838383" stroke-width="2" />
        <path d="M26.5166 7.50916C29.3649 10.1269 32.9828 18.458 26.5166 24.9921" stroke="#838383" stroke-width="2" />
        <title>Playing</title>
      </svg>
    </>
  )
}
